import React from 'react';
import {connect} from 'react-redux';

import {pgettext} from 'topmeteo/utils/i18n';

import DateSelect from '../../base-image/components/DateSelect';

import Map from './Map';
import DateSwitch from './DateSwitch';
import ConfigToggle from './ConfigToggle';
import LocationSearch from './LocationSearch';
import LocationSelect from './LocationSelect';
import StartHourSelect from './StartHourSelect';
import ResolutionSelect from './ResolutionSelect';

/* Translators: location forecast start hour picker */
const StartLabel = pgettext('location forecast', 'start');

/* Translators: location forecast resolution picker */
const ResolutionLabel = pgettext('location forecast', 'grid');

const Controls = ({panelOpen}) => (
    <ul id="lfc-controls">
        <li id="location-favorites">
            <LocationSelect />
        </li>
        <li id="location-map">
            <Map.Toggle />
        </li>
        <li className="mobile-only" id="config-mobile">
            <ConfigToggle panelOpen={panelOpen} />
        </li>
        {panelOpen === 'config-header' && (
            <li id="config-header" className="mobile-only">
                <nav className="config-area">
                    <ul>
                        <li id="start-hour">
                            <div className="react-wrapper">
                                <StartHourSelect />
                            </div>
                        </li>
                        <li id="resolution-select">
                            <div className="react-wrapper">
                                <ResolutionSelect />
                            </div>
                        </li>
                    </ul>
                    <div className="clearer" />
                </nav>
            </li>
        )}
        <li id="date-select">
            <DateSelect />
        </li>
        <li id="start-hour" className="desktop-only">
            <span className="label desktop-only">{StartLabel}</span>
            <div id="start-hour-content" className="react-wrapper">
                <StartHourSelect />
            </div>
        </li>
        <li id="location-search">
            <LocationSearch />
        </li>
        <li className="desktop-only" id="date-switcher">
            <DateSwitch />
        </li>
        <li id="resolution-select" className="desktop-only">
            <span className="label desktop-only">{ResolutionLabel}</span>
            <div id="resolution-select-content" className="react-wrapper">
                <ResolutionSelect />
            </div>
        </li>
    </ul>
);

const mapStateToProps = ({panelOpen}) => ({panelOpen});

export default connect(mapStateToProps)(Controls);
